var _g, _path, _g2, _path2, _g3, _g4, _path3, _g5, _path4, _path5, _path6, _path7, _g6, _g7, _g8, _rect, _rect2, _rect3, _path8, _g9, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.333,
    height: 129.95,
    viewBox: "0 0 129.333 129.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_116531",
    "data-name": "Group 116531",
    transform: "translate(-32.619 -23.748)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    transform: "translate(33.119 27.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116503",
    "data-name": "Group 116503",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122544",
    "data-name": "Path 122544",
    d: "M56.934,154.991c-15.169-17.862-9.854-44.337-.825-52.36s23.356-12.43,31.032-21.8,16.516-16.086,32.677-11.249,15.919,17.4,20.767,25.175,26.462,12.116,25.231,32.066-14.949,19.916-21.206,24.832-16.125,28.126-35.874,28.368C84.533,180.316,69.772,170.107,56.934,154.991Z",
    transform: "translate(-43.308 -58.835)",
    fill: "#eef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116498",
    "data-name": "Group 116498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116495",
    "data-name": "Group 116495",
    transform: "translate(57.623)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122545",
    "data-name": "Path 122545",
    d: "M245.889,35.941l-.854,2.973a9.76,9.76,0,0,0-2.219.9l-2.739-1.5-2.448,2.417,1.524,2.7a9.5,9.5,0,0,0-.916,2.191l-3.012.843v3.425l3.012.843a9.491,9.491,0,0,0,.916,2.191l-1.524,2.7,2.448,2.417,2.739-1.5a9.76,9.76,0,0,0,2.219.9l.854,2.973h3.47l.854-2.973a9.755,9.755,0,0,0,2.219-.9l2.739,1.5,2.448-2.417-1.523-2.7a9.491,9.491,0,0,0,.916-2.191l3.012-.843V46.469l-3.012-.843a9.5,9.5,0,0,0-.916-2.191l1.523-2.7-2.448-2.417-2.739,1.5a9.755,9.755,0,0,0-2.219-.9l-.854-2.973Zm1.735,5.844a6.4,6.4,0,1,1-6.48,6.4A6.452,6.452,0,0,1,247.624,41.785Z",
    transform: "translate(-235.224 -35.941)",
    fill: "none",
    stroke: "#7371fc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116496",
    "data-name": "Group 116496",
    transform: "translate(111.831 56.349)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122546",
    "data-name": "Path 122546",
    d: "M432.45,233.58l-.568,1.978a6.485,6.485,0,0,0-1.477.6l-1.822-1-1.629,1.608,1.014,1.8a6.332,6.332,0,0,0-.61,1.458l-2,.561v2.279l2,.561a6.332,6.332,0,0,0,.61,1.458l-1.014,1.8,1.629,1.608,1.822-1a6.486,6.486,0,0,0,1.477.6l.568,1.978h2.309l.569-1.978a6.49,6.49,0,0,0,1.477-.6l1.822,1,1.629-1.608-1.014-1.8a6.321,6.321,0,0,0,.609-1.458l2-.561v-2.279l-2-.561a6.321,6.321,0,0,0-.609-1.458l1.014-1.8-1.629-1.608-1.822,1a6.489,6.489,0,0,0-1.477-.6l-.569-1.978Zm1.154,3.889a4.257,4.257,0,1,1-4.312,4.257A4.293,4.293,0,0,1,433.6,237.469Z",
    transform: "translate(-425.354 -233.58)",
    fill: "none",
    stroke: "#7371fc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116497",
    "data-name": "Group 116497",
    transform: "translate(0 61.559)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122547",
    "data-name": "Path 122547",
    d: "M48.539,251.854l-1.235,4.3A14.119,14.119,0,0,0,44.1,257.46l-3.96-2.175L36.6,258.78l2.2,3.909a13.738,13.738,0,0,0-1.324,3.168l-4.355,1.219v4.952l4.355,1.219a13.731,13.731,0,0,0,1.324,3.168l-2.2,3.909,3.54,3.495,3.96-2.175a14.118,14.118,0,0,0,3.209,1.307l1.235,4.3h5.017l1.235-4.3A14.116,14.116,0,0,0,58,281.645l3.96,2.175,3.54-3.495-2.2-3.909a13.718,13.718,0,0,0,1.324-3.168l4.355-1.219v-4.952l-4.355-1.219a13.725,13.725,0,0,0-1.324-3.168l2.2-3.909-3.54-3.495L58,257.46a14.117,14.117,0,0,0-3.209-1.307l-1.235-4.3Zm2.508,8.45a9.25,9.25,0,1,1-9.369,9.249A9.329,9.329,0,0,1,51.048,260.3Z",
    transform: "translate(-33.119 -251.854)",
    fill: "none",
    stroke: "#7371fc",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116502",
    "data-name": "Group 116502",
    transform: "translate(1.357 28.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116499",
    "data-name": "Group 116499",
    transform: "translate(55.254 81.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122548",
    "data-name": "Path 122548",
    d: "M235.106,428.778h0a6.311,6.311,0,0,1,3.383-3.3l.048-.02-.206-.092a6.306,6.306,0,0,1-3.2-3.165l-.029-.063-.159.313a6.306,6.306,0,0,1-2.835,2.791l-.437.217.026.011a6.321,6.321,0,0,1,3.312,3.115Z",
    transform: "translate(-231.676 -422.137)",
    fill: "#32338c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122549",
    "data-name": "Path 122549",
    d: "M254.544,444.242h0a3.156,3.156,0,0,1,1.692-1.65l.024-.01-.1-.046a3.152,3.152,0,0,1-1.6-1.583l-.014-.032-.079.156a3.154,3.154,0,0,1-1.417,1.4l-.219.108.013.005a3.159,3.159,0,0,1,1.656,1.558Z",
    transform: "translate(-246.798 -435.566)",
    fill: "#7371fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116500",
    "data-name": "Group 116500",
    transform: "translate(113.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122550",
    "data-name": "Path 122550",
    d: "M446.6,139.606h0a4.718,4.718,0,0,0-2.529-2.468l-.035-.015.154-.069a4.714,4.714,0,0,0,2.39-2.366l.021-.047.119.234a4.714,4.714,0,0,0,2.119,2.086l.327.162-.02.008a4.724,4.724,0,0,0-2.476,2.329Z",
    transform: "translate(-442.094 -134.641)",
    fill: "#7371fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122551",
    "data-name": "Path 122551",
    d: "M438.5,151.167h0a2.358,2.358,0,0,0-1.265-1.234l-.018-.007.077-.034a2.358,2.358,0,0,0,1.2-1.183l.011-.024.059.117a2.357,2.357,0,0,0,1.06,1.043l.164.081-.01,0a2.363,2.363,0,0,0-1.238,1.165Z",
    transform: "translate(-437.219 -144.681)",
    fill: "#32338c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116501",
    "data-name": "Group 116501",
    transform: "translate(0 24.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122552",
    "data-name": "Path 122552",
    d: "M47.262,227.169h0a4.716,4.716,0,0,0-2.53-2.468l-.035-.015.154-.068a4.714,4.714,0,0,0,2.39-2.366l.021-.048.119.234a4.715,4.715,0,0,0,2.119,2.086l.327.162-.02.008a4.724,4.724,0,0,0-2.476,2.329Z",
    transform: "translate(-42.753 -222.204)",
    fill: "#7371fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122553",
    "data-name": "Path 122553",
    d: "M39.16,238.731h0A2.358,2.358,0,0,0,37.9,237.5l-.018-.007.077-.034a2.358,2.358,0,0,0,1.2-1.183l.011-.024.059.117a2.358,2.358,0,0,0,1.059,1.043l.164.081-.01,0a2.363,2.363,0,0,0-1.238,1.164Z",
    transform: "translate(-37.878 -232.245)",
    fill: "#32338c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(37.437 23.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116510",
    "data-name": "Group 116510",
    transform: "translate(81.029)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_122554",
    "data-name": "Path 122554",
    d: "M339.687,115.549a18,18,0,0,1,6,1.929,48.493,48.493,0,0,1,14.388,11.385c1.62,1.883,3.15,4.025,3.4,6.5.291,2.83-1.132,5.522-2.509,8.011-1.147,2.072-2.531,4.336-4.822,4.938-1.877.493-3.844-.295-5.54-1.239a33.907,33.907,0,0,1-14.454-17.019,22.51,22.51,0,0,1-1.664-10.317c.066-1.024-2.617-1.118-1.9-1.93A9.424,9.424,0,0,1,339.687,115.549Z",
    transform: "translate(-332.465 -89.359)",
    fill: "#32338c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116504",
    "data-name": "Group 116504",
    transform: "translate(16.965 27.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122555",
    "data-name": "Path 122555",
    d: "M399.273,137.287a6.658,6.658,0,0,1-.726.832,9.9,9.9,0,0,1-3.19,1.973,6.929,6.929,0,0,1-2.712.608c-.1,0-.208-.01-.312-.02a1.416,1.416,0,0,0,.222.5,2.023,2.023,0,0,0,1.566.621,10.217,10.217,0,0,0,4.575-.794.825.825,0,0,0,.409-.29.875.875,0,0,0,.072-.507A18.868,18.868,0,0,1,399.273,137.287Z",
    transform: "translate(-392.229 -132.486)",
    fill: "#f8ab73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122556",
    "data-name": "Path 122556",
    d: "M395.1,128.053a9.906,9.906,0,0,0,3.19-1.973,6.655,6.655,0,0,0,.726-.832c.158-1.582.429-3.138.512-4.746-1.621-.381-4.24,1.3-5.37,2.364A6.592,6.592,0,0,0,392,128.232a2.972,2.972,0,0,0,.072.409c.1.01.208.018.312.02A6.929,6.929,0,0,0,395.1,128.053Z",
    transform: "translate(-391.969 -120.447)",
    fill: "#fe814b"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122557",
    "data-name": "Path 122557",
    d: "M373.43,44.257a20.259,20.259,0,0,0,2.6-4.388,6.821,6.821,0,0,0,.144-4.988,4.16,4.16,0,0,0-3.973-2.656c.533-1.093-.116-2.3-1.006-3.132a6.174,6.174,0,0,0-3.317-1.377c-3.4-.524-6.868.189-10.305.038a8.06,8.06,0,0,1-3.669-.87,3.693,3.693,0,0,1-1.976-3.049,7.055,7.055,0,0,0-.869,3.2,2.964,2.964,0,0,0,1.634,2.554,2.675,2.675,0,0,1-2.659-1.132,5.1,5.1,0,0,1-.962-2.873,5.657,5.657,0,0,0-2.241,3.036,7.23,7.23,0,0,0-.367,3.451,4.249,4.249,0,0,0,1.8,2.892,2.567,2.567,0,0,1-1.416-.056,2.133,2.133,0,0,0,.846,1.682,4.976,4.976,0,0,0,1.752.831c2.139.64,4.386.813,6.578,1.24,5.174,1.007,9.954,3.4,14.872,5.3A5.02,5.02,0,0,0,373.43,44.257Z",
    transform: "translate(-342.414 -23.834)",
    fill: "#fe642f"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116505",
    "data-name": "Group 116505",
    transform: "translate(7.74 5.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122558",
    "data-name": "Path 122558",
    d: "M377.49,72.543a14.216,14.216,0,0,1,.472-8.059c-2.586,2.435-6.392,3.034-9.911,2.557a10.2,10.2,0,0,0,3.106-2.337c-3.5-.228-7.107.623-10.6.3a19.085,19.085,0,0,0-.8,3.63,26.486,26.486,0,0,0,.307,7.547A16.34,16.34,0,0,0,363,83.813c1.721,2.153,4.6,3.565,7.271,2.884a8.43,8.43,0,0,0,2.744-1.369,20.845,20.845,0,0,0,6.84-8.884A8.523,8.523,0,0,1,377.49,72.543Z",
    transform: "translate(-359.611 -58.3)",
    fill: "#f8ab74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122559",
    "data-name": "Path 122559",
    d: "M373.536,49.2a10.2,10.2,0,0,1-3.106,2.337c3.519.478,7.325-.122,9.911-2.557a14.216,14.216,0,0,0-.472,8.059,8.523,8.523,0,0,0,2.362,3.9c.2-.453.38-.91.551-1.371a18.382,18.382,0,0,0,1.286-6.184,10.254,10.254,0,0,0-1.726-6,11.762,11.762,0,0,0-7.572-4.328,11.509,11.509,0,0,0-4.341-.092c-1.9.376-4.492,1.445-5.725,3.046a11.806,11.806,0,0,0-1.766,3.488C366.429,49.821,370.037,48.97,373.536,49.2Z",
    transform: "translate(-361.99 -42.794)",
    fill: "#fe642f"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116506",
    "data-name": "Group 116506",
    transform: "translate(26.187 17.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122560",
    "data-name": "Path 122560",
    d: "M424.65,86.812a6.518,6.518,0,0,0-.2,3.44,2.881,2.881,0,0,0,1.333,2.218,2.119,2.119,0,0,0,1.907-.158,4.444,4.444,0,0,0,1.4-1.393,6.186,6.186,0,0,0,1.134-2.747,3.508,3.508,0,0,0-.821-2.79,2.593,2.593,0,0,0-2.766-.805A4,4,0,0,0,424.65,86.812Z",
    transform: "translate(-424.312 -84.423)",
    fill: "#f8ab73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122561",
    "data-name": "Path 122561",
    d: "M432.219,90.127a1.429,1.429,0,0,0-1.678-.458,2.339,2.339,0,0,0-1.249,1.336,6.953,6.953,0,0,0-.389,1.834,1.25,1.25,0,0,1,1.205-.511,1.1,1.1,0,0,1,.648,1.424,1.918,1.918,0,0,1-1.3,1.091",
    transform: "translate(-427.594 -88.102)",
    fill: "none",
    stroke: "#32338c",
    strokeWidth: 1.118
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122562",
    "data-name": "Path 122562",
    d: "M385.078,82.393a13.136,13.136,0,0,1-1.446,7.66,3.866,3.866,0,0,0,1.314.441",
    transform: "translate(-369.044 -65.697)",
    fill: "none",
    stroke: "#32338c",
    strokeWidth: 1.118
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116507",
    "data-name": "Group 116507",
    transform: "translate(12.935 25.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122563",
    "data-name": "Path 122563",
    d: "M385.577,120.7a2.16,2.16,0,0,0,.951.362c.893.084,1.735-.731,2.324-1.508A4.469,4.469,0,0,0,385.577,120.7Z",
    transform: "translate(-383.369 -118.079)",
    fill: "#fe632e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122564",
    "data-name": "Path 122564",
    d: "M380.66,115.543a9.14,9.14,0,0,1-2.826-1.138,8.2,8.2,0,0,0,2.208,2.621,4.469,4.469,0,0,1,3.276-1.146,9.4,9.4,0,0,0,.835-1.318A10,10,0,0,1,380.66,115.543Z",
    transform: "translate(-377.834 -114.405)",
    fill: "#32338c"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122565",
    "data-name": "Path 122565",
    d: "M373.6,89.043c.03.607-.261,1.114-.651,1.133s-.73-.457-.76-1.063.261-1.115.651-1.134S373.57,88.436,373.6,89.043Z",
    transform: "translate(-360.861 -69.69)",
    fill: "#32328c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122566",
    "data-name": "Path 122566",
    d: "M401.408,89.566c.03.607-.261,1.114-.651,1.134s-.73-.457-.76-1.064.261-1.114.651-1.134S401.378,88.96,401.408,89.566Z",
    transform: "translate(-380.741 -70.064)",
    fill: "#32328c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122567",
    "data-name": "Path 122567",
    d: "M366.747,78.931a3.907,3.907,0,0,1,1.543-1.5,2.963,2.963,0,0,1,2.116-.252",
    transform: "translate(-356.973 -61.902)",
    fill: "none",
    stroke: "#fe642e",
    strokeWidth: 4.471
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122568",
    "data-name": "Path 122568",
    d: "M400.589,78.931a3.909,3.909,0,0,0-1.543-1.5,2.963,2.963,0,0,0-2.116-.252",
    transform: "translate(-378.55 -61.902)",
    fill: "none",
    stroke: "#fe642e",
    strokeWidth: 4.471
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116508",
    "data-name": "Group 116508",
    transform: "translate(9.41 23.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122569",
    "data-name": "Path 122569",
    d: "M368.4,107.466c0,.485-.656.878-1.466.878s-1.466-.393-1.466-.878.656-.878,1.466-.878S368.4,106.981,368.4,107.466Z",
    transform: "translate(-365.47 -106.588)",
    fill: "#f8ab74",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122570",
    "data-name": "Path 122570",
    d: "M404.061,107.466c0,.485-.656.878-1.466.878s-1.466-.393-1.466-.878.656-.878,1.466-.878S404.061,106.981,404.061,107.466Z",
    transform: "translate(-390.962 -106.588)",
    fill: "#f8ab74",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116509",
    "data-name": "Group 116509",
    transform: "translate(6.004 0.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122571",
    "data-name": "Path 122571",
    d: "M365.68,24a4.813,4.813,0,0,0,2.678,5.386,7.662,7.662,0,0,0,3.1.488c2.605-.018,5.193-.518,7.8-.483a7.232,7.232,0,0,1,3.369.7,3.279,3.279,0,0,1,1.823,2.76",
    transform: "translate(-362.127 -24)",
    fill: "none",
    stroke: "#f8ab74",
    strokeWidth: 1.118
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122572",
    "data-name": "Path 122572",
    d: "M374.684,39.246a3.414,3.414,0,0,0-1.96-2.574,5.848,5.848,0,0,0-3.3-.416,21.808,21.808,0,0,0-3.274.81c-2.661.778-5.49,1.366-8.191.741a6.668,6.668,0,0,1-1.982-.772,5.13,5.13,0,0,1-1.982-6.533",
    transform: "translate(-353.522 -28.648)",
    fill: "none",
    stroke: "#f8ab74",
    strokeWidth: 1.118
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122573",
    "data-name": "Path 122573",
    d: "M406.02,56.054A2.236,2.236,0,0,0,405,55.061a3.589,3.589,0,0,0-3.379.363,13.048,13.048,0,0,0-2.6,2.4",
    transform: "translate(-386.051 -46.006)",
    fill: "none",
    stroke: "#f8ab74",
    strokeWidth: 1.118
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122574",
    "data-name": "Path 122574",
    d: "M437.6,58.891a2.054,2.054,0,0,1,1.8.465,3.263,3.263,0,0,1,.98,1.635,5.75,5.75,0,0,1-.082,3.118,10.6,10.6,0,0,1-1.375,2.831",
    transform: "translate(-413.627 -48.904)",
    fill: "none",
    stroke: "#f8ab74",
    strokeWidth: 1.118
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122575",
    "data-name": "Path 122575",
    d: "M429.758,63.77a1.522,1.522,0,0,1,1.2.494,3.077,3.077,0,0,1,.655,1.164,6.459,6.459,0,0,1,.029,4.08c-.036.111-.129.247-.236.2",
    transform: "translate(-408.022 -52.427)",
    fill: "none",
    stroke: "#f8ab74",
    strokeWidth: 1.118
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116511",
    "data-name": "Group 116511",
    transform: "translate(0 7.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18020",
    "data-name": "Rectangle 18020",
    width: 36.042,
    height: 39.177,
    transform: "translate(5.96 17.63) rotate(-7.352)",
    fill: "#eef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18021",
    "data-name": "Rectangle 18021",
    width: 36.042,
    height: 8.537,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 4.867, 9.163)",
    fill: "#7371fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18022",
    "data-name": "Rectangle 18022",
    width: 4.908,
    height: 39.177,
    transform: "translate(1.092 18.258) rotate(-7.352)",
    fill: "#91c4fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18023",
    "data-name": "Rectangle 18023",
    width: 4.908,
    height: 8.537,
    transform: "translate(0 9.791) rotate(-7.352)",
    fill: "#443dc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18024",
    "data-name": "Rectangle 18024",
    width: 5.508,
    height: 7.479,
    transform: "translate(8.723 20.055) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18025",
    "data-name": "Rectangle 18025",
    width: 5.508,
    height: 7.479,
    transform: "translate(15.206 19.219) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18026",
    "data-name": "Rectangle 18026",
    width: 5.508,
    height: 7.479,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 21.69, 18.382)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18027",
    "data-name": "Rectangle 18027",
    width: 5.508,
    height: 7.479,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 28.173, 17.546)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18028",
    "data-name": "Rectangle 18028",
    width: 5.508,
    height: 7.479,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 34.657, 16.709)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18029",
    "data-name": "Rectangle 18029",
    width: 5.508,
    height: 7.479,
    transform: "translate(9.805 28.441) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18030",
    "data-name": "Rectangle 18030",
    width: 5.508,
    height: 7.479,
    transform: "translate(16.288 27.605) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18031",
    "data-name": "Rectangle 18031",
    width: 5.508,
    height: 7.479,
    transform: "translate(22.772 26.768) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18032",
    "data-name": "Rectangle 18032",
    width: 5.508,
    height: 7.479,
    transform: "translate(29.255 25.932) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18033",
    "data-name": "Rectangle 18033",
    width: 5.508,
    height: 7.479,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 35.739, 25.095)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18034",
    "data-name": "Rectangle 18034",
    width: 5.508,
    height: 7.479,
    transform: "translate(10.887 36.827) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18035",
    "data-name": "Rectangle 18035",
    width: 5.508,
    height: 7.479,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 17.37, 35.991)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18036",
    "data-name": "Rectangle 18036",
    width: 5.508,
    height: 7.479,
    transform: "translate(23.854 35.154) rotate(-7.351)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18037",
    "data-name": "Rectangle 18037",
    width: 5.508,
    height: 7.479,
    transform: "translate(30.337 34.318) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18038",
    "data-name": "Rectangle 18038",
    width: 5.508,
    height: 7.479,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 36.821, 33.481)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18039",
    "data-name": "Rectangle 18039",
    width: 5.508,
    height: 7.479,
    transform: "translate(11.969 45.213) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18040",
    "data-name": "Rectangle 18040",
    width: 5.508,
    height: 7.479,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 18.452, 44.377)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18041",
    "data-name": "Rectangle 18041",
    width: 5.508,
    height: 7.479,
    transform: "translate(24.936 43.54) rotate(-7.352)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18042",
    "data-name": "Rectangle 18042",
    width: 5.508,
    height: 7.479,
    transform: "translate(31.419 42.704) rotate(-7.351)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18043",
    "data-name": "Rectangle 18043",
    width: 5.508,
    height: 7.479,
    transform: "matrix(0.992, -0.128, 0.128, 0.992, 37.903, 41.867)",
    fill: "#fefffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122576",
    "data-name": "Path 122576",
    d: "M57.506,67.325l-.31-2.405a2.754,2.754,0,0,1,2.379-3.084l1.672-.216A2.754,2.754,0,0,1,64.331,64l.535,4.146a2.754,2.754,0,0,1-2.379,3.084h0",
    transform: "translate(-54.632 -57.904)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.028
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122577",
    "data-name": "Path 122577",
    d: "M74.234,65.166l-.31-2.405A2.754,2.754,0,0,1,76.3,59.676l1.672-.216a2.754,2.754,0,0,1,3.084,2.379l.535,4.146a2.754,2.754,0,0,1-2.379,3.084h0",
    transform: "translate(-66.591 -56.361)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.028
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122578",
    "data-name": "Path 122578",
    d: "M90.963,63.008l-.31-2.405a2.754,2.754,0,0,1,2.379-3.084L94.7,57.3a2.754,2.754,0,0,1,3.084,2.379l.535,4.146a2.754,2.754,0,0,1-2.379,3.084h0",
    transform: "translate(-78.55 -54.818)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.028
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122579",
    "data-name": "Path 122579",
    d: "M107.692,60.849l-.31-2.405a2.754,2.754,0,0,1,2.379-3.084l1.672-.216a2.754,2.754,0,0,1,3.084,2.379l.535,4.146a2.754,2.754,0,0,1-2.379,3.084h0",
    transform: "translate(-90.51 -53.274)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.028
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122580",
    "data-name": "Path 122580",
    d: "M124.42,58.691l-.31-2.405a2.754,2.754,0,0,1,2.379-3.084l1.672-.216a2.754,2.754,0,0,1,3.084,2.379l.535,4.146a2.754,2.754,0,0,1-2.379,3.084h0",
    transform: "translate(-102.469 -51.732)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.028
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122581",
    "data-name": "Path 122581",
    d: "M141.149,56.532l-.31-2.405a2.754,2.754,0,0,1,2.379-3.084l1.672-.216a2.754,2.754,0,0,1,3.084,2.379l.535,4.146a2.754,2.754,0,0,1-2.379,3.084h0",
    transform: "translate(-114.428 -50.188)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.028
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122582",
    "data-name": "Path 122582",
    d: "M157.878,54.374l-.31-2.405a2.754,2.754,0,0,1,2.379-3.084l1.672-.216a2.754,2.754,0,0,1,3.084,2.379l.535,4.146a2.754,2.754,0,0,1-2.379,3.084h0",
    transform: "translate(-126.387 -48.645)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.028
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116516",
    "data-name": "Group 116516",
    transform: "translate(13.333 22.466)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1985",
    "data-name": "Ellipse 1985",
    cx: 43.691,
    cy: 43.691,
    r: 43.691,
    transform: "translate(0 0)",
    fill: "#32338c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1986",
    "data-name": "Ellipse 1986",
    cx: 43.691,
    cy: 43.691,
    r: 43.691,
    transform: "translate(2.055)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116512",
    "data-name": "Group 116512",
    transform: "translate(5.883 3.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122583",
    "data-name": "Path 122583",
    d: "M162.339,177.49A42.144,42.144,0,0,0,182.021,161.9c5.391-8.273,7.019-18.305,6.547-28.284a39.867,39.867,0,0,0-67.518,42.326C133.843,181.987,149.178,182.8,162.339,177.49Z",
    transform: "translate(-115.663 -116.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122584",
    "data-name": "Path 122584",
    d: "M202.073,177.633c.472,9.979-1.155,20.011-6.547,28.284a42.144,42.144,0,0,1-19.682,15.594c-13.161,5.309-28.5,4.5-41.289-1.552a39.867,39.867,0,1,0,67.518-42.326Z",
    transform: "translate(-129.169 -160.077)",
    fill: "#eef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122585",
    "data-name": "Path 122585",
    d: "M206.928,215.758,188.174,199.04,207.8,214.728Z",
    transform: "translate(-161.617 -171.552)",
    fill: "#32338c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122586",
    "data-name": "Path 122586",
    d: "M254.352,254.213l8.655,31.773-10.149-30.827Z",
    transform: "translate(-207.859 -210.995)",
    fill: "#32338c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1987",
    "data-name": "Ellipse 1987",
    cx: 2.954,
    cy: 2.954,
    r: 2.954,
    transform: "translate(42.792 40.737)",
    fill: "#fe814b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116513",
    "data-name": "Group 116513",
    transform: "translate(5.883 3.828)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6449",
    "data-name": "Line 6449",
    y2: 8.474,
    transform: "translate(39.863)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6450",
    "data-name": "Line 6450",
    y2: 8.474,
    transform: "translate(39.863 71.252)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6451",
    "data-name": "Line 6451",
    x1: 8.474,
    transform: "translate(71.252 39.863)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6452",
    "data-name": "Line 6452",
    x1: 8.474,
    transform: "translate(0 39.863)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116514",
    "data-name": "Group 116514",
    transform: "translate(12.099 10.043)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6453",
    "data-name": "Line 6453",
    x2: 7.153,
    y2: 4.544,
    transform: "translate(0 12.272)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6454",
    "data-name": "Line 6454",
    x2: 7.153,
    y2: 4.544,
    transform: "translate(60.142 50.479)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6455",
    "data-name": "Line 6455",
    x1: 4.544,
    y2: 7.153,
    transform: "translate(50.479)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6456",
    "data-name": "Line 6456",
    x1: 4.544,
    y2: 7.153,
    transform: "translate(12.272 60.142)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116515",
    "data-name": "Group 116515",
    transform: "translate(12.099 10.043)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6457",
    "data-name": "Line 6457",
    x1: 7.153,
    y2: 4.544,
    transform: "translate(60.142 12.272)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6458",
    "data-name": "Line 6458",
    x1: 7.153,
    y2: 4.544,
    transform: "translate(0 50.479)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6459",
    "data-name": "Line 6459",
    x2: 4.544,
    y2: 7.153,
    transform: "translate(12.272)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6460",
    "data-name": "Line 6460",
    x2: 4.544,
    y2: 7.153,
    transform: "translate(50.479 60.142)",
    fill: "none",
    stroke: "#32338c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.883
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116526",
    "data-name": "Group 116526",
    transform: "translate(68.134 72.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116523",
    "data-name": "Group 116523",
    transform: "translate(0)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18044",
    "data-name": "Rectangle 18044",
    width: 36.852,
    height: 47.536,
    transform: "translate(10.921 2.526) rotate(13.282)",
    fill: "#32338c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18045",
    "data-name": "Rectangle 18045",
    width: 36.852,
    height: 47.536,
    transform: "translate(11.586 2.684) rotate(13.282)",
    fill: "#91c4fb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18046",
    "data-name": "Rectangle 18046",
    width: 30.817,
    height: 40.169,
    transform: "translate(13.467 7.849) rotate(13.282)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18047",
    "data-name": "Rectangle 18047",
    d: "M5.047,0H12.4a5.047,5.047,0,0,1,5.047,5.047v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A5.047,5.047,0,0,1,5.047,0Z",
    transform: "matrix(0.973, 0.23, -0.23, 0.973, 22.188, 0)",
    fill: "#32338c"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116518",
    "data-name": "Group 116518",
    transform: "translate(14.199 11.417)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1988",
    "data-name": "Ellipse 1988",
    cx: 2.963,
    cy: 2.963,
    r: 2.963,
    transform: "translate(0 1.226) rotate(-11.937)",
    fill: "#eeeefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122587",
    "data-name": "Path 122587",
    d: "M344.5,325.408l1.238,2,3.561-2.2",
    transform: "translate(-342.375 -323.152)",
    fill: "none",
    stroke: "#fe814b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116517",
    "data-name": "Group 116517",
    transform: "translate(8.433 2.971)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6461",
    "data-name": "Line 6461",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0.851)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6462",
    "data-name": "Line 6462",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0.426 1.803)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6463",
    "data-name": "Line 6463",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0 3.605)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116520",
    "data-name": "Group 116520",
    transform: "translate(12.58 21.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122588",
    "data-name": "Path 122588",
    d: "M337.208,355.756a2.963,2.963,0,1,1-2.2-3.564A2.963,2.963,0,0,1,337.208,355.756Z",
    transform: "translate(-331.361 -352.112)",
    fill: "#eeeefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122589",
    "data-name": "Path 122589",
    d: "M336.9,357.607l1.238,2,3.561-2.2",
    transform: "translate(-335.323 -355.899)",
    fill: "none",
    stroke: "#fe814b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116519",
    "data-name": "Group 116519",
    transform: "translate(7.885 2.423)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6464",
    "data-name": "Line 6464",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0.851)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6465",
    "data-name": "Line 6465",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0.426 1.803)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6466",
    "data-name": "Line 6466",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0 3.605)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116522",
    "data-name": "Group 116522",
    transform: "translate(9.428 29.34)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1989",
    "data-name": "Ellipse 1989",
    cx: 2.963,
    cy: 2.963,
    r: 2.963,
    transform: "matrix(0.43, -0.903, 0.903, 0.43, 0, 5.35)",
    fill: "#eeeefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122590",
    "data-name": "Path 122590",
    d: "M329.3,389.806l1.238,2,3.561-2.2",
    transform: "translate(-326.737 -387.112)",
    fill: "none",
    stroke: "#fe814b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116521",
    "data-name": "Group 116521",
    transform: "translate(8.871 3.408)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6467",
    "data-name": "Line 6467",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0.851)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6468",
    "data-name": "Line 6468",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0.426 1.803)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6469",
    "data-name": "Line 6469",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0 3.605)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18048",
    "data-name": "Rectangle 18048",
    d: "M0,0H25.319a0,0,0,0,1,0,0V0a2.772,2.772,0,0,1-2.772,2.772H2.772A2.772,2.772,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(17.198 4.008) rotate(13.282)",
    fill: "#91c4fb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116525",
    "data-name": "Group 116525",
    transform: "translate(7.189 38.398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1990",
    "data-name": "Ellipse 1990",
    cx: 2.963,
    cy: 2.963,
    r: 2.963,
    transform: "matrix(0.845, -0.534, 0.534, 0.845, 0, 3.165)",
    fill: "#eeeefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122591",
    "data-name": "Path 122591",
    d: "M321.936,422.06l1.238,2,3.561-2.2",
    transform: "translate(-319.233 -419.228)",
    fill: "none",
    stroke: "#fe814b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116524",
    "data-name": "Group 116524",
    transform: "translate(9.009 3.547)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6470",
    "data-name": "Line 6470",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0.851)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6471",
    "data-name": "Line 6471",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0.426 1.803)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6472",
    "data-name": "Line 6472",
    x2: 16.324,
    y2: 3.853,
    transform: "translate(0 3.605)",
    fill: "none",
    stroke: "#91c4fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.198
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116530",
    "data-name": "Group 116530",
    transform: "translate(66.803 21.664)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6473",
    "data-name": "Line 6473",
    x1: 3,
    y2: 5.279,
    transform: "translate(35.235 19.797)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.118
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116529",
    "data-name": "Group 116529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122592",
    "data-name": "Path 122592",
    d: "M345.984,191.758a85.717,85.717,0,0,1-5.725,7.878c-2.848,3.363-6.863,7.135-6.863,7.135l-21.479-9,3.153-7.357,15.726,4.859,9.06-12.823Z",
    transform: "translate(-303.549 -158.892)",
    fill: "#32338c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116527",
    "data-name": "Group 116527",
    transform: "translate(0 23.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122593",
    "data-name": "Path 122593",
    d: "M290.7,196.2l3.387,1.423-2.221,5.182-2.2-.75-4.859.2-1.426-.713a1.027,1.027,0,0,1-.437-1.421l.389-.694-.344-.269a1.027,1.027,0,0,1-.082-1.547l.387-.374-.524-.71a1.027,1.027,0,0,1,.349-1.519l.534-.28-.173-.943a1.027,1.027,0,0,1,.766-1.183h0a2.415,2.415,0,0,1,1.982.385Z",
    transform: "translate(-282.569 -189.271)",
    fill: "#f8ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122594",
    "data-name": "Path 122594",
    d: "M300.518,188.378a20.357,20.357,0,0,1-2.265-6.9.414.414,0,0,0-.122-.322.346.346,0,0,0-.2-.048,1.446,1.446,0,0,0-1.3.95,2.149,2.149,0,0,0,.118,1.659.785.785,0,0,1,.11.356.686.686,0,0,1-.113.3l-.538.946A9.891,9.891,0,0,0,300.518,188.378Z",
    transform: "translate(-292.324 -181.106)",
    fill: "#f8ab72"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6474",
    "data-name": "Line 6474",
    x1: 2.2,
    y1: 1.829,
    transform: "translate(4.026 3.974)",
    fill: "none",
    stroke: "#32338c",
    strokeWidth: 0.559
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116528",
    "data-name": "Group 116528",
    transform: "translate(3.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122595",
    "data-name": "Path 122595",
    d: "M296.731,99.819l5.2,2.007a1.608,1.608,0,0,1,1.021,1.658l-.263,2.645-1.8,2.949a.752.752,0,0,1-.472-1.032c.265-.826,1.15-3.037,1.15-3.037v-1.563s-.852,3.606-1.666,4.276-3.757-.638-4.553-1.287c-.388-.316.3-1.337.4-2.859C295.842,101.976,295.386,99.879,296.731,99.819Z",
    transform: "translate(-295.23 -99.819)",
    fill: "#f8ab74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122596",
    "data-name": "Path 122596",
    d: "M307.487,104.058a10.206,10.206,0,0,1-1.861,6.833",
    transform: "translate(-302.662 -102.849)",
    fill: "none",
    stroke: "#32338c",
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122597",
    "data-name": "Path 122597",
    d: "M300.831,101.653a12.772,12.772,0,0,1-1.381,6.289.764.764,0,0,1-.368.412",
    transform: "translate(-297.984 -101.13)",
    fill: "none",
    stroke: "#32338c",
    strokeWidth: 0.559
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.f5b9674da121a82ab538a1715e28417f.svg";
export { ForwardRef as ReactComponent };